import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectWorkExperience  {
    _originalTypeClassName = "zERP.BO.ProjectWorkExperience";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectWorkExperience.translate = translateService;
}
this.Id = null;
this.Revnum = null;
this.Code = null;
this.Project = null;
this.Duties = null;
this.DateFrom = null;
this.DateTo = null;
this.DurationYear = null;
this.DurationMonth = null;
this.DurationDay = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Revnum:any;
Code:any;
Project:any;
Duties:any;
DateFrom:any;
DateTo:any;
DurationYear:any;
DurationMonth:any;
DurationDay:any;
WorkExperience:any;
Employee:any;
Employer:any;
static setWorkExperience = ($this, value) => {
var oldValue = $this.WorkExperience;
$this.WorkExperience = value;
if (value != null) {
if (oldValue != null) {
Domain.WorkExperience.removeProjectWorkExperience(oldValue, $this);
}
Domain.WorkExperience.addProjectWorkExperience(value, $this);
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setEmployer = ($this, value) => {
var oldValue = $this.Employer;
$this.Employer = value;
if (value != null) {
}
}

static GetClassName(): any{return "ProjectWorkExperience";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}